import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IInvoiceState }      from 'Redux/Slices/Invoice/InvoiceSlice';
import { Invoice }            from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const updateInvoiceRequest = (state: Draft<IInvoiceState>, { type }: PayloadAction<{ id: string, formData: any }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.lastUpdateId = null;
  state.updatedAt = Date.now();
};

export const updateInvoiceSuccess = (state: Draft<IInvoiceState>, { type, payload }: PayloadAction<{
  invoice: Invoice
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.lastUpdateId = payload.invoice.id;
  state.entries = { ...state.entries, [payload.invoice.id]: payload.invoice };
};

export const updateInvoiceFailure = (state: Draft<IInvoiceState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
